// test949
(949 && 0);
